import { useEffect, useState } from 'react';

import { getCompanyAnalysisReport } from '../services/companiesService';
import { CompanyAnalysisResponse } from '../types';

export const useCompanyAnalysisReport = (companyUuid?: string | null) => {
  const [analysisReport, setAnalysisReport] = useState<CompanyAnalysisResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAnalysisReport = async (uuid: string) => {
    try {
      setLoading(true);
      setError(null);
      const data = await getCompanyAnalysisReport(uuid);
      setAnalysisReport(data);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : 'Erro ao buscar relatório de análise da company'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyUuid) {
      fetchAnalysisReport(companyUuid);
    }
  }, [companyUuid]);

  const refetch = () => {
    if (companyUuid) {
      fetchAnalysisReport(companyUuid);
    }
  };

  return {
    analysisReport,
    loading,
    error,
    refetch,
  };
};
